// Voix des dialogues : pendant que la boîte de dialogue écrit une réplique, de petits sons synthétisés suivent les
// lettres (façon Animal Crossing), au timbre et à la hauteur du PNJ qui parle. Partagé par le serveur (voix envoyée avec
// le dialogue), le jeu (qui la joue) et l'administration (réglée sur chaque PNJ).

export const VOICE_TONES = {
  none: 'Muette',
  soft: 'Douce',
  bright: 'Claire',
  deep: 'Grave',
  nasal: 'Nasillarde',
  robot: 'Robot',
  cry: 'Cri de monstre',
} as const;
export type VoiceTone = keyof typeof VOICE_TONES;
export const isVoiceTone = (value: unknown): value is VoiceTone => typeof value === 'string' && Object.hasOwn(VOICE_TONES, value);

export interface Voice {
  tone: VoiceTone;
  /** Décalage de hauteur, en demi-tons (de -VOICE_PITCH_RANGE à +VOICE_PITCH_RANGE ; 0 : hauteur du timbre). */
  pitch: number;
}

export const VOICE_PITCH_RANGE = 12;
export const DEFAULT_VOICE: Voice = { tone: 'soft', pitch: 0 };

/** Voix d'un monstre d'une espèce (acteur d'une scène) : un cri, plus ou moins aigu selon l'espèce. */
export const creatureVoice = (speciesId: number): Voice => ({ tone: 'cry', pitch: ((speciesId * 5) % 13) - 6 });
